// extracted by mini-css-extract-plugin
export var orderSummary = "_s4-0";
export var showMoreLessButton = "_s4-1";